// extracted by mini-css-extract-plugin
export default {"registerCard":"UDP1l5tCOixhst35r9Dp"};